import { createFileRoute, Link } from "@tanstack/react-router";
import { ensureAuthenticated } from "../utils/auth.ts";
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Container,
  Grid2 as Grid,
  Typography,
  useTheme,
} from "@mui/material";
import { ProductMaterialIcon } from "@floriday/floriday-icons";
import { Wc, AcUnit, Security } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute("/")({
  beforeLoad: ensureAuthenticated,
  component: RouteComponent,
});

const navigationCards = [
  {
    title: "Producten",
    description: "Overzicht producten en onderhoud belangrijkste reglementaire kenmerk en afwijkende koelregimes per product",
    Icon: ProductMaterialIcon,
    to: "/products",
    color: "#2E7D32",
  },
  {
    title: "Productgroepen",
    description: "Overzicht productgroepen en onderhoud koelregimes per productgroep",
    Icon: Wc,
    to: "/cooling-regimes-product-group",
    color: "#1976D2",
  },
  {
    title: "Koelregime opties",
    description: "Onderhoud koelprioriteiten en koeltemperaturen",
    Icon: AcUnit,
    to: "/cooling-regimes",
    color: "#0288D1",
  },
  ...(import.meta.env.DEV ? [{
    title: "Claims & Tokens",
    description: "Bekijk ID token en access token claims voor debugging",
    Icon: Security,
    to: "/claims",
    color: "#9C27B0",
  }] : []),
];

function RouteComponent() {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Container maxWidth="lg" sx={{ py: 6 }}>
      <Box sx={{ mb: 6, textAlign: "center" }}>
        <Typography
          variant="h3"
          component="h1"
          gutterBottom
          sx={{ fontWeight: 600 }}
        >
          {t("title")}
        </Typography>
        <Typography variant="h6" color="text.secondary" sx={{ mt: 2 }}>
          Welkom bij het Productadministratie systeem
        </Typography>
      </Box>

      <Grid container spacing={4}>
        {navigationCards.map((card) => (
          <Grid size={{ xs: 12, sm: 6, md: 4 }} key={card.to}>
            <Card
              sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                transition: "transform 0.2s, box-shadow 0.2s",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: theme.shadows[8],
                },
              }}
            >
              <CardActionArea
                component={Link}
                to={card.to}
                sx={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  p: 3,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: 64,
                    height: 64,
                    borderRadius: 2,
                    backgroundColor: card.color,
                    color: "white",
                    mb: 2,
                  }}
                >
                  <card.Icon sx={{ fontSize: 32 }} />
                </Box>
                <CardContent sx={{ p: 0, flexGrow: 1 }}>
                  <Typography
                    variant="h5"
                    component="h2"
                    gutterBottom
                    sx={{ fontWeight: 600 }}
                  >
                    {card.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {card.description}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Box sx={{ mt: 6, textAlign: "center" }}>
        <Typography variant="body2" color="text.secondary">
          Selecteer een module om te starten
        </Typography>
      </Box>
    </Container>
  );
}
